import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { FileText } from 'lucide-react';

const AdditionalInfoForm = ({ data, onSave }) => {
  const [content, setContent] = useState(data || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(content);
  };

  const wordCount = content.trim().split(/\s+/).filter(w => w.length > 0).length;

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-900">
          <strong>Optional Section:</strong> Use this space to explain any circumstances or provide additional context:
          <br />• Academic disruptions (illness, family issues)
          <br />• COVID-19 impact on your education
          <br />• Gaps in your education
          <br />• Other relevant information not covered elsewhere
          <br />• Maximum 650 words
        </p>
      </div>

      <div>
        <Label htmlFor="additionalInfo">Additional Information</Label>
        <Textarea
          id="additionalInfo"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="If there is anything you would like to share with colleges..."
          rows={15}
          className="font-serif"
        />
        <p className="text-sm text-gray-500 mt-2">
          Word count: <span className={wordCount > 650 ? 'text-red-600 font-semibold' : 'font-semibold'}>{wordCount}</span> / 650
        </p>
        {wordCount > 650 && (
          <p className="text-sm text-red-600">⚠️ Exceeds maximum word count</p>
        )}
      </div>

      <div className="flex justify-end">
        <Button type="submit">Save & Continue</Button>
      </div>
    </form>
  );
};

export default AdditionalInfoForm;